// extracted by mini-css-extract-plugin
export default {"ctaButton":"Buttons_ctaButton__LeRG8"};